import React from "react";
import {
  Input,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";
import ImagePreviewBox from "./ImagePreviewBox";

const NoticeOptionSection = ({
  fileNamePop,
  previewUrlPop,
  onFileChangePop,
  fileInputRefPop,
  name,
}: {
  fileNamePop: string;
  previewUrlPop: string | null;
  onFileChangePop: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  fileInputRefPop: React.RefObject<HTMLInputElement>;
  name: string;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit.notice_option.title")}
      rows={[
        {
          label: t("quest_edit.notice_option.form.popup_image.label"),
          children: (
            <Stack spacing={2}>
              <Stack direction="row" spacing={4} alignItems="center">
                <Stack spacing={2} sx={{ flexGrow: 1, width: "60%" }}>
                  <Stack direction="row" spacing={1}>
                    <TextField
                      size="small"
                      value={fileNamePop}
                      placeholder={t(
                        "quest_edit.basic_info.form.image.placeholder",
                      )}
                      sx={{ width: "40%" }}
                      InputProps={{ readOnly: true }}
                    />
                    <SubActionButton
                      onClick={() => fileInputRefPop.current?.click()}
                      sx={{ minWidth: 40, p: 0 }}
                    >
                      {t("quest_edit.button.add_img")}
                    </SubActionButton>
                    <Input
                      type="file"
                      sx={{ display: "none" }}
                      inputRef={fileInputRefPop}
                      onChange={onFileChangePop}
                      inputProps={{ accept: "image/*" }}
                    />
                  </Stack>
                </Stack>

                <ImagePreviewBox previewUrl={previewUrlPop} alt={name} />
              </Stack>

              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: 1 }}
              >
                {t("quest_edit.notice_option.form.popup_image.note")}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: 1 }}
              >
                {t("quest_edit.notice_option.form.popup_image.sub_note")}
              </Typography>
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default NoticeOptionSection;
